import { css } from "styled-components";
import { token } from "./token.js";
const textStyles = {
  paragraphS: css(["font-weight:normal;font-size:", ";line-height:", ";"], token.fontSize75, token.lineHeightText),
  paragraphM: css(["font-weight:normal;font-size:", ";line-height:", ";"], token.fontSize100, token.lineHeightText),
  paragraphL: css(["font-weight:normal;font-size:", ";line-height:", ";"], token.fontSize200, token.lineHeightText),
  uiTextXS: css(["font-weight:normal;font-size:", ";line-height:20px;"], token.fontSize50),
  uiTextS: css(["font-weight:normal;font-size:", ";line-height:20px;"], token.fontSize75),
  uiTextM: css(["font-weight:normal;font-size:", ";line-height:20px;"], token.fontSize100),
  uiTextL: css(["font-weight:normal;font-size:", ";line-height:24px;"], token.fontSize200),
  headingXS: css(["font-weight:600;font-size:", ";line-height:", ";"], token.fontSize100, token.lineHeightHeading),
  headingS: css(["font-weight:600;font-size:", ";line-height:", ";"], token.fontSize200, token.lineHeightHeading),
  headingM: css(["font-weight:normal;font-size:", ";line-height:", ";"], token.fontSize400, token.lineHeightHeading),
  headingL: css(["font-weight:normal;font-size:", ";line-height:", ";"], token.fontSize600, token.lineHeightHeading),
  headingXL: css(["font-weight:normal;font-size:", ";line-height:", ";"], token.fontSize800, token.lineHeightHeading),
  headingXXL: css(["font-weight:normal;font-size:", ";line-height:", ";"], token.fontSize1000, token.lineHeightHeading)
};
export {
  textStyles
};
//# sourceMappingURL=textStyles.js.map
